
import http from './http'
import apiRouter from './api-routes'

export const createQrCode = async (data) => {
    return http.post(apiRouter.baseURL + apiRouter.qrCode.create, data)
}

export const getCampagnePositions = async (data) => {
    return http.get(apiRouter.baseURL + apiRouter.rapports.getCampagnePositions, {
        params: data
    })
}

export const getDatePositions = async (data) => {
    return http.get(apiRouter.baseURL + apiRouter.rapports.getDatePositions,{
        params: data
    })
}

export const postAddNewCommercial = async (data) => {
    return http.post(apiRouter.baseURL + apiRouter.commercial.postAddNewCommercial, data)
    
}

export const getAllCommercials = async () => {
    return http.get(apiRouter.baseURL + apiRouter.commercial.getAllCommercials)
}